import { IAction } from '../../../__core/Interfaces/IAction';
import { IEvent } from '../../../__core/Interfaces/IEvent';
import MATERIAL_ACTIONS from '../Actions/ActionTypes';
import { SideMenuResponse } from '../Types/SideMenuResponse';
import { menuInitState } from './MaterialInitState';
import DIRECT_ACCESS_ACTIONS from '../../DirectAccess/Actions/ActionTypes';

export const menuReducer = (
  state: SideMenuResponse = menuInitState,
  action: IAction<SideMenuResponse>
): SideMenuResponse => {
  switch (action.type) {
    case MATERIAL_ACTIONS.FETCH_SIDE_MENU:
    case DIRECT_ACCESS_ACTIONS.DIRECT_ACCESS_FETCH_MENU:
      return { ...action.payload };

    case MATERIAL_ACTIONS.CLEAR_MATERIAL_DETAILS:
      return { ...menuInitState };

    default:
      return state;
  }
};

export const menuLoaderReducer = (state = false, action: IEvent): boolean => {
  switch (action.type) {
    case MATERIAL_ACTIONS.FETCH_SIDE_MENU_START:
      return true;

    case MATERIAL_ACTIONS.FETCH_SIDE_MENU_FINISH:
      return false;

    default:
      return state;
  }
};
